export const logoutAction = () => dispatch => {
  dispatch({
    type: 'LOGOUT_ACTION'
  })
  dispatch({
    type: 'COGNITO_LOGOUT'
  })
}